import Avatar from '@material-ui/core/Avatar/Avatar';
import Menu from '@material-ui/core/Menu/Menu';
import { makeStyles } from '@material-ui/styles';
import { SvgIcon } from 'components/SvgIcon';
import { enLang } from 'interfaces/IProductData';
import React, { useState, useRef } from 'react';
import { langService } from 'services/LangService';
import MenuItem from '@material-ui/core/MenuItem';
import { useObservable } from 'react-use-observable';

const useStyles = makeStyles({
  '@global': {
    '.country-menu-item': {
      lineHeight: '15px',

      '& img': {
        height: '15px',
        width: '20px',
        marginRight: '3px'
      },

      '& svg': {
        width: '15px',
        marginRight: '5px'
      }
    }
  },
  component: {
    '&.chk-config-country': {
      float: 'right',

      '& img': {
        height: '15px',
        width: '15px',
        marginTop: '-5px'
      },

      '& .chk-config-button': {
        position: 'relative',
        display: 'inline-block',
        padding: '2px 25px 2px 5px',
        border: '1px solid #cecece',
        borderRadius: '4px',
        width: 'auto',

        '& svg': {
          width: '15px'
        },

        '& .chk-option-active': {
          marginLeft: '10px',
          fontSize: '12px',
          color: '#232323',
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          height: '21px',
          lineHeight: '28px'
        }
      }
    },

    '& .chk-configCountry___avatar': {
      alignSelf: 'flex-end',
      position: 'absolute',
      margin: '45px 20px',

      '& img': {
        height: '32px',
        width: '32px'
      }
    }
  }
});

const options = [{ lang: enLang.PT_BR, text: 'Português' }, { lang: enLang.PT_PT, text: 'Portugues (PT)' }, { lang: enLang.EN_US, text: 'English' }];

interface IProps {
  circle?: string;
}

const ConfigCountry: React.FC<IProps> = React.memo(props => {
  const [lang] = useObservable(() => langService.getLang(), []);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const classes = useStyles({});
  const selectLang = (lang: enLang) => {
    langService.setLang(lang);
    setOpen(false);
  };

  if (!lang) {
    return <div />;
  }

  const selectedLang = options.find(o => o.lang == lang);

  return (
    <div className={`chk-config-country ${!props.circle ? '' : 'chk-configCountry___avatar'} ${classes.component}`} ref={ref} id="chk-config-country">
      {props.circle ? (
        <div className={'classes.row'}>
          <Avatar id="chk-selectlang-circle-button" onClick={() => setOpen(true)} alt={selectedLang.text} className={'classes.avatar'}>
            <SvgIcon name={`flag_${selectedLang.lang}_round`} />
          </Avatar>
        </div>
      ) : (
        <a id={`chk-selectlang-button-${lang}`} className="chk-config-button" onClick={() => setOpen(true)}>
          <SvgIcon name={`flag_${selectedLang.lang}`} />
          <span className="chk-option-active theme-language-bar-selected">{selectedLang.text}</span>
        </a>
      )}

      <Menu id="lock-menu" anchorEl={ref.current} open={open} onClose={() => setOpen(false)}>
        {options.map(option => (
          <MenuItem key={option.lang} selected={lang === option.lang} onClick={() => selectLang(option.lang)}>
            <div className="country-menu-item">
              <SvgIcon name={`flag_${option.lang}`} />
              {option.text}
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
});

export default ConfigCountry;
